<div class="version-parent" clickOutside (clickOutside)="clickedOutside()">
  <div class="dropdown">
    <button class="version-button" (click)="showVersions = !showVersions">
      <span>Version</span>
      <button-icon 
        icon="dropdown"
        [ngClass]="showVersions ? 'dropdown-rotate-icon' : '-icon-padding'"
        iconcolor="-colorSupportingWhite"
        iconattributes="-xsm">
      </button-icon>
    </button>
    @if (showVersions) {
      <div class="dropdown-wrapper">
        @for (version of versions; track version) {  
          <div class="dropdown-content">
            <a [routerLink]="version.route">
              {{version.name}}
            </a>
          </div>
        }
      </div>
    }
  </div>
</div>
